import EventPage from "./event_page";
import { OverlayScrollbars } from "overlayscrollbars";
import { Calendar } from "@fullcalendar/core";
import momentTimezonePlugin from "../modules/moment_timezone_plugin";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import { initializeModals } from "../modules/utils";

class Agenda extends EventPage {
  constructor(node) {
    super(node);
    this.calendarElement = this.element.querySelector(".js-calendar");
    this.calendarDefaultOptions.titleRangeSeparator = ` ${this.calendarElement.dataset.rangeSeparator} `;
    this.calendarDefaultOptions.buttonText = {
      today: this.calendarElement.dataset.todayText,
    };
    this.modalsInitialized = false;
    this.prepare();
    this.dateSetTimeOut = null;
    this.pastEventText = this.element.dataset.pastEventText;
  }

  initialize() {
    super.initialize();

    this.calendar = new Calendar(this.calendarElement, {
      ...this.calendarDefaultOptions,
      plugins: [dayGridPlugin, timeGridPlugin, listPlugin, momentTimezonePlugin],
      locale: this.fullLocale,
      initialView: "timeGridWeek",
      initialDate: this.startDate,
      themeSystem: "standard",
      allDaySlot: true,
      dayHeaderContent: "",
      slotLabelFormat: {
        hour: "numeric",
        minute: "2-digit",
        hour12: false,
        omitZeroMinute: true,
        meridiem: false,
      },
      events: this.events,
      dayHeaderDidMount: (args) => {
        const dayHeaderDate = args.date.getDate();
        const dayHeaderDay = args.date.toLocaleDateString(this.fullLocale, { weekday: "long" }).slice(0, 2);
        const div = document.createElement("div");
        div.innerHTML = `<div class="fc-day-header-day">${dayHeaderDay}</div><div class="fc-day-header-date">${dayHeaderDate}</div>`;
        args.el.appendChild(div);
        args.el.appendChild(this.timeZoneSelect);
      },
      slotLabelContent: (argument) => {
        return this.slotLabelContent(argument);
      },
      allDayContent: (argument) => {
        return this.allDayContent(argument);
      },
      datesSet: (args) => {
        this.agendaWrapper.classList.add("is-loading");
        clearTimeout(this.dateSetTimeOut);

        this.handleNewDateSet(args);
      },
      eventDidMount: (args) => {
        args.el.dataset.js = "ajax-modal";
        args.el.dataset.errorMessage = this.calendarElement.dataset.errorMessage;

        if (!args.event.allDay && args.event.end < new Date()) {
          args.el.querySelector(".fc-event-time").innerHTML = this.pastEventText;
        }

        initializeModals(args.el.parentElement);
      },
    });

    // Calendar
    this.calendar.render();
    this.calendarScrollElement = document.querySelector(".fc-scroller.fc-scroller-liquid-absolute");
    OverlayScrollbars(this.calendarScrollElement, {});
    this.timeZoneButton = this.calendarElement.querySelector(".fc-timeZoneButton-button");
    this.timeZoneButton.innerHTML = `GMT ${this.selectedGmtOffset}`;

    this.addTimeZoneSelect();
  }

  airDatepickerOnSelect(date) {
    this.calendar.gotoDate(date);
  }

  removeAllEvents() {
    this.calendar.removeAllEvents();
  }

  addEvents() {
    this.events.forEach((event) => {
      this.calendar.addEvent(event);
    });

    initializeModals(this.calendarElement);

    this.addTimeZoneSelect();
  }

  updateCalendarTimezone() {
    const gmt = this.getGmtOffset(this.selectedTimeZone);
    this.timeZoneButton.innerHTML = `GMT ${gmt}`;

    this.calendar.setOption("allDayContent", (argument) => {
      return this.allDayContent(argument);
    });
    this.calendar.setOption("slotLabelContent", (argument) => {
      return this.slotLabelContent(argument);
    });
  }

  slotLabelContent(argument) {
    let slotLabelContent = [];
    const options = {
      hour: "numeric",
      hour12: false,
    };
    if (this.currentTimeZone != this.selectedTimeZone) {
      let div = document.createElement("div");
      options.timeZone = this.currentTimeZone;
      const hourInTimezone = argument.date.toLocaleTimeString(this.fullLocale, options).split(":")[0];
      div.innerHTML = hourInTimezone.replace(/^0/, "");
      slotLabelContent.push(div);
    }
    let div = document.createElement("div");
    div.innerHTML = `${argument.text.replace(/^0/, "")}`;
    slotLabelContent.push(div);
    return { domNodes: slotLabelContent };
  }

  allDayContent() {
    let allDayContent = [];
    let div = document.createElement("div");
    div.innerHTML = `GMT <br> ${this.selectedGmtOffset}`;
    allDayContent.push(div);
    if (this.currentTimeZone != this.selectedTimeZone) {
      let div = document.createElement("div");
      let gmt = this.getGmtOffset(this.selectedTimeZone);
      div.innerHTML = `GMT <br> ${gmt}`;
      allDayContent.push(div);
    }

    return { domNodes: allDayContent };
  }
}

const agendaElement = document.querySelector('[data-js="agenda"]');
if (agendaElement) {
  new Agenda(agendaElement);
}
